/**
 * @fileoverview Provide the shared native text/password boundary for forms. The parent owns value, validation, and persistence; the forwarded ref lets the caller coordinate focus. Password reveal changes local visibility without changing the saved credential or its authorization boundary.
 */

import React, { forwardRef, useState } from 'react';
import AppIcon from "./AppIcon";

const baseStyle = {
  width: '100%',
  padding: '0.6rem 0.75rem',
  borderRadius: '6px',
  border: '1px solid var(--surface-border)',
  fontSize: '1rem',
  backgroundColor: 'var(--surface-section)',
  color: 'var(--text-color)',
  fontFamily: 'inherit',
  outline: 'none'
};

const borderlessStyle = {
  width: '100%',
  padding: '0.6rem 0',
  borderRadius: '0',
  border: 'none',
  borderBottom: '1px solid transparent',
  fontSize: '1rem',
  backgroundColor: 'transparent',
  color: 'var(--text-color)',
  fontFamily: 'inherit',
  outline: 'none'
};



const AppTextInput = forwardRef(function AppTextInput(
{ id, value, onChange, onBlur, placeholder, disabled, variant, onKeyDown, className, style: extraStyle, type = 'text', toggleMask, ...inputProps },
ref)
{
  const [showPassword, setShowPassword] = useState(false);
  const isbl = variant === 'borderless';
  const isPasswordToggle = toggleMask && type === 'password';
  const inputType = isPasswordToggle ? showPassword ? 'text' : 'password' : type;

  const style = {
    ...(isbl ? borderlessStyle : baseStyle),
    cursor: disabled ? 'not-allowed' : undefined,
    opacity: disabled ? 0.6 : 1,
    ...(isPasswordToggle ? { paddingRight: '2.5rem' } : {}),
    ...extraStyle
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
            <input
        ref={ref}
        id={id}
        type={inputType}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={onKeyDown}
        className={className || ''}
        style={style}
        {...inputProps}
        onFocus={isbl ? (e) => {e.target.style.borderBottom = '1px solid var(--primary-color)';} : undefined}
        onBlur={(e) => {if (isbl) e.target.style.borderBottom = '1px solid transparent';if (onBlur) onBlur(e);}} />

            {isPasswordToggle &&
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShowPassword((prev) => !prev)}
        style={{
          position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', padding: '0.25rem',
          color: 'var(--text-color-secondary, #64748b)', fontSize: '1rem'
        }}>

                    <AppIcon icon={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'} />
                </button>}

        </div>);

});

export default AppTextInput;
